import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import RichTextStepEditorForm from './RichTextStepEditorForm';
import VideoStepEditorForm from './VideoStepEditorForm';
import PdfStepEditorForm from './PdfStepEditorForm';
import ImageStepEditorForm from './ImageStepEditorForm';
import QuestionStepEditorForm from './QuestionStepEditorForm';
import { useGuideBuilderGuide } from '../../contexts/GuideBuilderContext';
import { GuideStepType } from '@/services/apis/guides';

const StepEditor: React.FC = () => {
  // Get values from context

  const {
    state: { selectedStep },
  } = useGuideBuilderGuide();

  const { t } = useTranslation('admin');

  const renderStepEditor = () => {
    if (!selectedStep) {
      return (
        <div className="flex items-center justify-center h-full text-gray-500">
          <div className="text-center">
            <FileText className="w-16 h-16 mx-auto mb-4 text-gray-300" />
            <p className="text-lg font-medium mb-2">{t('guides.builder.stepEditor.noStepSelected')}</p>
            <p className="text-sm">{t('guides.builder.stepEditor.noStepDescription')}</p>
          </div>
        </div>
      );
    }

    switch (selectedStep?.type) {
      case GuideStepType.RICH_TEXT:
        return <RichTextStepEditorForm />;
      case GuideStepType.VIDEO:
        return <VideoStepEditorForm />;
      case GuideStepType.IMAGE:
        return <ImageStepEditorForm />;
      case GuideStepType.PDF:
        return <PdfStepEditorForm />;
      case GuideStepType.QUESTION:
        return <QuestionStepEditorForm />;
      default:
        return <div>Unknown step type</div>;
    }
  };

  return (
    <div className="flex-1 flex flex-col">
      <div className="flex-1 p-6">
        <AnimatePresence mode="wait">{renderStepEditor()}</AnimatePresence>
      </div>
    </div>
  );
};

export default StepEditor;
